import type { FC } from 'react';
import { useMemo } from 'react';

import { useAppSelector } from 'features/app/hooks';
import { DialPadButton } from 'features/dial-pad/components';
import {
  calculatorDealerButtons,
  phoneDealerButtons,
} from 'features/dial-pad/constants';
import { DialPadVariant } from 'features/dial-pad/enums';
import type { DialPadValue } from 'features/dial-pad/interfaces';
import { dialPadVariantSelector } from 'features/dial-pad/store';

interface DialPadButtonListProps {
  onMouseDown: (value: DialPadValue) => void;
}

export const DialPadButtonList: FC<DialPadButtonListProps> = ({
  onMouseDown,
}) => {
  const dialPadVariant = useAppSelector(dialPadVariantSelector);

  const dialPadButtonContent = useMemo(() => {
    return dialPadVariant === DialPadVariant.PHONE_DEALER
      ? phoneDealerButtons
      : calculatorDealerButtons;
  }, [dialPadVariant]);

  return (
    <>
      {dialPadButtonContent.map(({ value, text }) => (
        <DialPadButton
          key={value}
          value={value}
          text={text}
          onMouseDown={() => onMouseDown(value)}
        />
      ))}
    </>
  );
};
